// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadTextContentReportRequestModel from '../../model/download-text-content-report-request-model';
import DownloadTextContentReportRequestDTO from '../dto/download-text-content-report-request-dto';
import dtoSchema from '../schemas/download-text-content-report-request-schema';

export default abstract class DownloadTextContentReportRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadTextContentReportRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.scope = data.scope;
      this.language = data.language;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  scope?: string;
  /**
  */
  language?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<DownloadTextContentReportRequestDTO>): DownloadTextContentReportRequestModel;
  static toModel(dto: DeepPartial<DownloadTextContentReportRequestDTO> | undefined | null): DownloadTextContentReportRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadTextContentReportRequestDTO> | undefined | null): DownloadTextContentReportRequestModel | undefined {
    return dto ? new DownloadTextContentReportRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadTextContentReportRequestModel> | DownloadTextContentReportRequestModel): DownloadTextContentReportRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      scope: unwrapped.scope,
      language: unwrapped.language,
      searchCriteria: unwrapped.searchCriteria,
    } as DownloadTextContentReportRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DownloadTextContentReportRequestModel, can not map to DownloadTextContentReportRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
